(function () {
  var MIN_YEAR = 2022;

  var today = new Date();
  today.setHours(0, 0, 0, 0);
  var currentYear = today.getFullYear();
  var currentMonth = today.getMonth();

  // Find each event-nav on the page (supports multiple sections)
  document.querySelectorAll('.event-nav').forEach(function (nav) {
    var section = nav.closest('.multicolumn');
    if (!section) return;

    var items = section.querySelectorAll('[data-event-date]');
    if (!items.length) return;

    // ── Build localized month names via Intl.DateTimeFormat ──
    var locale = nav.getAttribute('data-locale') || document.documentElement.lang || 'en';
    var MONTHS = [];
    var MONTHS_FULL = [];
    for (var m = 0; m < 12; m++) {
      var d = new Date(2026, m, 1);
      MONTHS.push(new Intl.DateTimeFormat(locale, { month: 'short' }).format(d));
      MONTHS_FULL.push(new Intl.DateTimeFormat(locale, { month: 'long' }).format(d));
    }

    var tEventPassed = nav.getAttribute('data-t-event-passed') || 'Event has passed';
    var tNoEventsPast = nav.getAttribute('data-t-no-events-past') || 'No events occurred in __MONTH__ __YEAR__';
    var tNoEventsFuture = nav.getAttribute('data-t-no-events-future') || 'No events planned yet in __MONTH__ __YEAR__';
    var tNoEventsPastYear = 'No events occurred in __YEAR__';
    var tNoEventsFutureYear = 'No events planned yet in __YEAR__';
    var tNoUpcoming = nav.getAttribute('data-t-no-upcoming') || 'No upcoming events';

    var tShowAll = nav.getAttribute('data-t-show-all') || 'Show all upcoming events';

    var yearLabel = nav.querySelector('[data-year-label]');
    var monthBar = nav.querySelector('[data-month-bar]');
    var yearPrev = nav.querySelector('[data-year-prev]');
    var yearNext = nav.querySelector('[data-year-next]');

    var viewYear = currentYear;
    var selectedMonth = null;

    // ── Helpers ──
    function parseDate(str) {
      var p = str.split('-');
      return new Date(+p[0], +p[1] - 1, +p[2]);
    }

    function isPastEvent(dateStr) {
      return parseDate(dateStr) < today;
    }

    function isPastMonth(year, month) {
      if (year < currentYear) return true;
      if (year === currentYear && month < currentMonth) return true;
      return false;
    }

    function monthsWithEvents() {
      var set = {};
      items.forEach(function (item) {
        var raw = item.getAttribute('data-event-date');
        if (!raw) return;
        var d = parseDate(raw);
        if (d.getFullYear() === viewYear) set[d.getMonth()] = true;
      });
      return set;
    }

    // ── Past-event treatment (badge + styling) ──
    function applyPastBadges() {
      items.forEach(function (item) {
        var raw = item.getAttribute('data-event-date');
        if (!raw || !isPastEvent(raw)) return;

        item.classList.add('event-multicolumn--past');

        var imageWrap = item.querySelector('.event-multicolumn__image-wrap');
        if (imageWrap && !imageWrap.querySelector('.event-multicolumn__past-badge')) {
          var badge = document.createElement('div');
          badge.className = 'event-multicolumn__past-badge';
          badge.setAttribute('aria-label', tEventPassed);
          badge.textContent = tEventPassed;
          imageWrap.appendChild(badge);
        }

        var link = item.querySelector('.link.animate-arrow');
        if (link && link.tagName === 'A') {
          var span = document.createElement('span');
          span.className = 'link event-multicolumn__link-disabled';
          span.textContent = link.textContent.replace(/\s*\u2192?\s*$/, '').trim();
          link.parentNode.replaceChild(span, link);
        }
      });
    }

    // ── Helper: create "Show all upcoming events" button ──
    function createShowAllBtn(extraClass) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'event-nav__show-all' + (extraClass ? ' ' + extraClass : '');
      btn.textContent = tShowAll;
      btn.addEventListener('click', function () {
        selectedMonth = null;
        viewYear = currentYear;
        render();
      });
      return btn;
    }

    // ── Filter cards ──
    function filterCards() {
      var anyVisible = false;
      var allPast = true;

      items.forEach(function (item) {
        var raw = item.getAttribute('data-event-date');
        if (!raw) { item.style.display = ''; return; }

        var d = parseDate(raw);
        var show = false;

        if (selectedMonth !== null) {
          // Specific month selected — show only that month+year
          show = (d.getFullYear() === viewYear && d.getMonth() === selectedMonth);
        } else if (viewYear === currentYear) {
          // Current year, no month filter — show upcoming events for this year
          show = (d.getFullYear() === viewYear && !isPastEvent(raw));
        } else {
          // Other year, no month filter — show all events for that year
          show = (d.getFullYear() === viewYear);
        }

        item.style.display = show ? '' : 'none';
        if (show) {
          anyVisible = true;
          if (!isPastEvent(raw)) allPast = false;
        }
      });

      var grid = items[0] ? items[0].parentNode : null;
      if (!grid) return;

      // Clean up previous injected elements
      var oldEmpty = grid.querySelector('.event-empty');
      if (oldEmpty) oldEmpty.remove();
      var oldShowAll = grid.querySelector('.event-nav__show-all--grid');
      if (oldShowAll) oldShowAll.remove();

      if (selectedMonth !== null) {
        if (!anyVisible) {
          // No events — pick message based on past vs future month
          var emptyMsg = isPastMonth(viewYear, selectedMonth)
            ? tNoEventsPast
            : tNoEventsFuture;
          emptyMsg = emptyMsg.replace('__MONTH__', MONTHS_FULL[selectedMonth] || '').replace('__YEAR__', viewYear);

          var empty = document.createElement('li');
          empty.className = 'event-empty multicolumn-list__item grid__item';
          var msg = document.createElement('div');
          msg.textContent = emptyMsg;
          empty.appendChild(msg);
          // Show "show all" for future months too
          empty.appendChild(createShowAllBtn());
          grid.appendChild(empty);
        } else if (allPast) {
          // Has events but they're all past — add "show all" as a grid column
          var showAllLi = document.createElement('li');
          showAllLi.className = 'event-nav__show-all--grid multicolumn-list__item grid__item';
          showAllLi.appendChild(createShowAllBtn());
          grid.appendChild(showAllLi);
        }
      } else if (!anyVisible) {
        // No month selected, no visible events
        var empty = document.createElement('li');
        empty.className = 'event-empty multicolumn-list__item grid__item';

        if (viewYear > currentYear) {
          // Future year with no events
          var msg = document.createElement('div');
          msg.textContent = tNoEventsFutureYear.replace('__YEAR__', viewYear);
          empty.appendChild(msg);
          empty.appendChild(createShowAllBtn());
        } else if (viewYear < currentYear) {
          // Past year with no events
          var msg = document.createElement('div');
          msg.textContent = tNoEventsPastYear.replace('__YEAR__', viewYear);
          empty.appendChild(msg);
          empty.appendChild(createShowAllBtn());
        } else {
          empty.textContent = tNoUpcoming;
        }

        grid.appendChild(empty);
      }
    }

    // ── Render month bar ──
    function renderMonthBar() {
      var hasEvents = monthsWithEvents();
      monthBar.innerHTML = '';

      MONTHS.forEach(function (label, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'event-nav__month';

        if (hasEvents[i]) btn.classList.add('event-nav__month--has-events');
        if (isPastMonth(viewYear, i)) btn.classList.add('event-nav__month--past');
        if (selectedMonth === i) btn.classList.add('event-nav__month--active');

        btn.innerHTML =
          '<span class="event-nav__dot"></span>' +
          '<span class="event-nav__month-label">' + label + '</span>';

        btn.addEventListener('click', function () {
          selectedMonth = (selectedMonth === i) ? null : i;
          render();
        });

        monthBar.appendChild(btn);
      });

      yearLabel.textContent = viewYear;
      yearPrev.disabled = (viewYear <= MIN_YEAR);
    }

    // ── Full render ──
    function render() {
      renderMonthBar();
      filterCards();
    }

    // ── Events ──
    yearPrev.addEventListener('click', function () {
      if (viewYear > MIN_YEAR) {
        viewYear--;
        selectedMonth = null;
        render();
      }
    });

    yearNext.addEventListener('click', function () {
      viewYear++;
      selectedMonth = null;
      render();
    });


    // ── Init ──
    applyPastBadges();
    render();
  });
})();
